module.exports = __webpack_public_path__ + "img/type-of-registration-1.6e247356.jpeg";